interface EmptyStateProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}

export function EmptyState({ title, description = '', actions }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h1 className="text-2xl font-bold">{title}</h1>
      {description && <p className="text-center text-gray-500 mt-2">{description}</p>}
      {actions && <div className="mt-4">{actions}</div>}
    </div>
  );
}
